import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../store/store';
import { fetchTaxonomiesMenu } from './formTaxonomiesApi';
import type { FormTaxonomyMenuResponse, FormTaxonomyNode } from './types';

interface FormTaxonomiesState {
  data: FormTaxonomyNode[];
  organization: FormTaxonomyMenuResponse['organization'];
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

const initialState: FormTaxonomiesState = {
  data: [],
  organization: null,
  status: 'idle',
  error: null,
};

export const loadTaxonomiesMenu = createAsyncThunk<FormTaxonomyMenuResponse, string[] | undefined>(
  'formTaxonomies/loadMenu',
  async (roles) => fetchTaxonomiesMenu(roles),
);

const slice = createSlice({
  name: 'formTaxonomies',
  initialState,
  reducers: {
    resetTaxonomies(state) {
      state.data = [];
      state.organization = null;
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadTaxonomiesMenu.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(loadTaxonomiesMenu.fulfilled, (state, action: PayloadAction<FormTaxonomyMenuResponse>) => {
        state.status = 'succeeded';
        state.data = action.payload.data;
        state.organization = action.payload.organization;
      })
      .addCase(loadTaxonomiesMenu.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? 'Error al cargar menú';
      });
  },
});

export const { resetTaxonomies } = slice.actions;
export default slice.reducer;

export const selectTaxonomiesTree = (state: RootState): FormTaxonomyNode[] =>
  state.formTaxonomies.data;
export const selectTaxonomiesOrganization = (state: RootState) =>
  state.formTaxonomies.organization;
export const selectTaxonomiesStatus = (state: RootState) => state.formTaxonomies.status;
